import {
  cmmdRuntimeInventoryResource,
  useCmmdRuntimeInventorySnapshot,
} from "../../cmmd/cmmdRuntimeInventoryResource";
import { Button } from "../ui/button";

export function RemoteInventoryRecovery() {
  const inventory = useCmmdRuntimeInventorySnapshot();
  if (inventory.error === null) return null;
  return (
    <div role="status" className="flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground">
      <span>Could not load Environment details. Your saved conversation is still available.</span>
      <Button
        variant="ghost"
        className="min-h-12"
        onClick={() =>
          void cmmdRuntimeInventoryResource.refresh({ allWorkspaces: true }).catch(() => undefined)
        }
      >
        Retry loading Environment
      </Button>
    </div>
  );
}
